import _ from "lodash";
import {
    FETCH_CONJOINTS,
    FETCH_CONJOINT,
    ADD_CONJOINT_ATTRIBUTE,
    EDIT_CONJOINT_ATTRIBUTE,
    MOVE_CONJOINT_ATTRIBUTE,
    DELETE_CONJOINT_ATTRIBUTE,
    EDIT_CONJOINT_PRICES,
    ADD_CONJOINT_EXCLUSION,
    EDIT_CONJOINT_EXCLUSION,
    DELETE_CONJOINT_EXCLUSION,
    EDIT_CONJOINT_SETTINGS,
    FETCH_CONJOINT_PREVIEW,
    FETCH_GABOR_GRANGERS,
    FETCH_GABOR_GRANGER,
    EDIT_GABOR_GRANGER_PRICES,
    EDIT_GABOR_GRANGER_SETTINGS,
    FETCH_GABOR_GRANGER_PREVIEW,
    FETCH_VAN_WESTENDORPS,
    FETCH_VAN_WESTENDORP,
    EDIT_VAN_WESTENDORP_PRODUCT,
    EDIT_VAN_WESTENDORP_SETTINGS,
    EDIT_GABOR_GRANGER_PRODUCT,
    FETCH_FIRMOGRAPHICS,
    FETCH_FIRMOGRAPHIC,
    EDIT_FIRMOGRAPHIC_QUESTION,
    MOVE_FIRMOGRAPHIC_QUESTION,
    DELETE_FIRMOGRAPHIC_QUESTION,
    ADD_SURVEY,
    FETCH_SURVEYS,
    FETCH_SURVEY,
    EDIT_SURVEY_DESIGN,
    ADD_SURVEY_RESPONDENT,
    EDIT_SURVEY_RESPONDENT,
    DELETE_SURVEY_RESPONDENT,
    TOGGLE_CONJOINT_READY,
    TOGGLE_FIRMOGRAPHIC_READY,
    TOGGLE_GABOR_GRANGER_READY,
    TOGGLE_VAN_WESTENDORP_READY,
    FETCH_TEST_SURVEY,
    TAKE_SURVEY,
    START_SURVEY,
    ANSWER_SURVEY,
    ANALYZE_SURVEY,
} from '../actions/types'

const INITIAL_STATE = {
    surveys: {},
    firmographic: {},
    conjoint: {},
    gaborGranger: {},
    vanWestendorp: {},
    preview: {
        firmographic: {},
        conjoint: {},
        gaborGranger: {},
        vanWestendorp: {}
    },
    test: {},
    survey: {
        surveyDesign: {},
        surveyCompleted: false,
        stepCompleted: null,
    },
    analysis: {}
}

const surveyReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ADD_SURVEY:
            return { ...state, surveys: { ...state.surveys, [action.payload.surveys.id]: action.payload.surveys } }

        case FETCH_SURVEYS:
            return { ...state, surveys: { ...state.surveys, ..._.mapKeys(action.payload.surveys, 'id') } }

        case FETCH_SURVEY:
            return { ...state, surveys: { ...state.surveys, [action.payload.surveys.id]: action.payload.surveys } };

        case FETCH_TEST_SURVEY:
            return { ...state, test: { ...state.test, surveyDesign: action.payload.test_survey, surveyCompleted: false, stepCompleted: null, status: 'started' } }

        case TAKE_SURVEY:
            return { ...state, survey: { ...state.survey, surveyDesign: action.payload.survey_design, surveyCompleted: action.payload.survey_completed, stepCompleted: action.payload.step_completed, status: action.payload.status } }

        case ANSWER_SURVEY:
            return { ...state, survey: { ...state.survey, surveyCompleted: action.payload.survey_completed, stepCompleted: action.payload.step_completed } }

        case START_SURVEY:
            return {
                ...state,
                surveys: {
                    ...state.surveys,
                    [action.payload.id]: {
                        ...state.surveys[action.payload.id],
                        status: action.payload.status
                    }
                }
            };

        case EDIT_SURVEY_DESIGN:
            return { ...state, surveys: { ...state.surveys, [action.payload.surveys.id]: action.payload.surveys } };

        case ADD_SURVEY_RESPONDENT:
            const updatedSurvey = {
                ...state.surveys[action.payload.id],
                respondents: [...state.surveys[action.payload.id].respondents, action.payload.respondents], // Add new respondent object to the list
                respondents_counter: state.surveys[action.payload.id].respondents_counter + 1
            };
            return {
                ...state,
                surveys: {
                    ...state.surveys,
                    [action.payload.id]: updatedSurvey
                }
            };

        case EDIT_SURVEY_RESPONDENT:
            // Create a deep copy of the state
            const newSurveyState = _.cloneDeep(state);

            // Take the survey object with the matching id
            const surveyObject = newSurveyState.surveys[action.payload.id];

            // If the survey object is found, find the respondent object with the matching id
            if (surveyObject) {
                const respondentObject = surveyObject.respondents.find(respondent => respondent.id === action.payload.respondents.id);

                // If the question object is found, update its properties
                if (respondentObject) {
                    Object.assign(respondentObject, action.payload.respondents);
                }
            }

            // Return the modified state
            return newSurveyState;

        case DELETE_SURVEY_RESPONDENT:
            const respondents = _.filter(state.surveys[action.payload.id].respondents, respondent => respondent.id !== action.payload.respondent_id);
            return {
                ...state,
                surveys: {
                    ...state.surveys,
                    [action.payload.id]: {
                        ...state.surveys[action.payload.id],
                        respondents: respondents
                    }
                }
            };

        case FETCH_FIRMOGRAPHICS:
            return { ...state, firmographic: { ...state.firmographic, ..._.mapKeys(action.payload.firmographic_surveys, 'id') } };

        case FETCH_FIRMOGRAPHIC:
            return { ...state, firmographic: { ...state.firmographic, [action.payload.firmographic_surveys.id]: action.payload.firmographic_surveys } };

        case TOGGLE_FIRMOGRAPHIC_READY:
            return {
                ...state,
                firmographic: {
                    ...state.firmographic,
                    [action.payload.id]: {
                        ...state.firmographic[action.payload.id],
                        component_ready: action.payload.component_ready
                    }
                }
            };

        case EDIT_FIRMOGRAPHIC_QUESTION:
            // Create a deep copy of the state
            const newFirmographicState = _.cloneDeep(state);

            // Take the firmographic object with the matching id
            const firmographicObject = newFirmographicState.firmographic[action.payload.id];

            // If the firmographic object is found, find the question object with the matching id
            if (firmographicObject) {
                const questionObject = firmographicObject.questions.find(question => question.id === action.payload.firmographic_questions.id);

                // If the question object is found, update its properties
                if (questionObject) {
                    Object.assign(questionObject, action.payload.firmographic_questions);
                }
            }

            // Return the modified state
            return newFirmographicState;

        case MOVE_FIRMOGRAPHIC_QUESTION:
            // Create a deep copy of the state
            const newFirmographicStateMove = _.cloneDeep(state);

            // Take the firmographic object with the matching id
            const firmographicObjectMove = newFirmographicStateMove.firmographic[action.payload.id];

            // If the firmographic object is found, find the question object with the matching id
            if (firmographicObjectMove) {
                // let questionsMove = action.payload.firmographic_questions
                action.payload.firmographic_questions.forEach(questionMove => {
                    const questionObject = firmographicObjectMove.questions.find(question => question.id === questionMove.id);

                    // If the question object is found, update its properties
                    if (questionObject) {
                        Object.assign(questionObject, questionMove);
                    }
                })
            }

            return newFirmographicStateMove

        case DELETE_FIRMOGRAPHIC_QUESTION:
            const questions = _.filter(state.firmographic[action.payload.id].questions, question => question.id !== action.payload.question_id);
            return {
                ...state,
                firmographic: {
                    ...state.firmographic,
                    [action.payload.id]: {
                        ...state.firmographic[action.payload.id],
                        questions: questions
                    }
                }
            };

        case FETCH_CONJOINTS:
            return { ...state, conjoint: { ...state.conjoint, ..._.mapKeys(action.payload.conjoint_surveys, 'id') } };

        case FETCH_CONJOINT:
            return { ...state, conjoint: { ...state.conjoint, [action.payload.conjoint_surveys.id]: action.payload.conjoint_surveys } };

        case TOGGLE_CONJOINT_READY:
            return {
                ...state,
                conjoint: {
                    ...state.conjoint,
                    [action.payload.id]: {
                        ...state.conjoint[action.payload.id],
                        component_ready: action.payload.component_ready
                    }
                }
            };

        case EDIT_CONJOINT_ATTRIBUTE:
            // Create a deep copy of the state
            const newState = _.cloneDeep(state);

            // Take the conjoint object with the matching id
            const conjointObject = newState.conjoint[action.payload.id];

            // If the conjoint object is found, find the attribute object with the matching id
            if (conjointObject) {
                const attributeObject = conjointObject.attributes.find(attribute => attribute.id === action.payload.conjoint_attributes.id);

                // If the attribute object is found, update its properties
                if (attributeObject) {
                    Object.assign(attributeObject, action.payload.conjoint_attributes);
                }
            }

            // Return the modified state
            return newState;

        case MOVE_CONJOINT_ATTRIBUTE:
            // Create a deep copy of the state
            const newStateMove = _.cloneDeep(state);

            // Take the conjoint object with the matching id
            const conjointObjectMove = newStateMove.conjoint[action.payload.id];

            // If the conjoint object is found, find the attribute object with the matching id
            if (conjointObjectMove) {
                // let attributesMove = action.payload.conjoint_attributes
                action.payload.conjoint_attributes.forEach(attributeMove => {
                    const attributeObject = conjointObjectMove.attributes.find(attribute => attribute.id === attributeMove.id);

                    // If the attribute object is found, update its properties
                    if (attributeObject) {
                        Object.assign(attributeObject, attributeMove);
                    }
                })
            }

            return newStateMove

        case DELETE_CONJOINT_ATTRIBUTE:
            const { id, attribute_id } = action.payload;
            const attributes = _.filter(state.conjoint[id].attributes, attribute => attribute.id !== attribute_id);
            return {
                ...state,
                conjoint: {
                    ...state.conjoint,
                    [id]: {
                        ...state.conjoint[id],
                        attributes: attributes
                    }
                }
            };

        case ADD_CONJOINT_ATTRIBUTE:
            const updatedConjoint = {
                ...state.conjoint[action.payload.id],
                attributes: [...state.conjoint[action.payload.id].attributes, action.payload.conjoint_attributes] // Add new attribute object to the list
            };
            return {
                ...state,
                conjoint: {
                    ...state.conjoint,
                    [action.payload.id]: updatedConjoint
                }
            };

        case EDIT_CONJOINT_PRICES:
            return { ...state, conjoint: { ...state.conjoint, [action.payload.conjoint_surveys.id]: action.payload.conjoint_surveys } };

        case ADD_CONJOINT_EXCLUSION:
            return { ...state, conjoint: { ...state.conjoint, [action.payload.conjoint_surveys.id]: action.payload.conjoint_surveys } };

        case EDIT_CONJOINT_EXCLUSION:
            return { ...state, conjoint: { ...state.conjoint, [action.payload.conjoint_surveys.id]: action.payload.conjoint_surveys } };

        case DELETE_CONJOINT_EXCLUSION:
            const exclusions = _.filter(state.conjoint[action.payload.id].exclusions, exclusion => exclusion.id !== action.payload.exclusion_id);
            return {
                ...state,
                conjoint: {
                    ...state.conjoint,
                    [action.payload.id]: {
                        ...state.conjoint[action.payload.id],
                        exclusions: exclusions
                    }
                }
            };

        case EDIT_CONJOINT_SETTINGS:
            return { ...state, conjoint: { ...state.conjoint, [action.payload.conjoint_surveys.id]: action.payload.conjoint_surveys } };

        case FETCH_CONJOINT_PREVIEW:
            return { ...state, preview: { ...state.preview, conjoint: action.payload.conjoint_options } }

        case FETCH_GABOR_GRANGERS:
            return { ...state, gaborGranger: { ...state.gaborGranger, ..._.mapKeys(action.payload.gabor_granger_surveys, 'id') } };

        case FETCH_GABOR_GRANGER:
            return { ...state, gaborGranger: { ...state.gaborGranger, [action.payload.gabor_granger_surveys.id]: action.payload.gabor_granger_surveys } };

        case TOGGLE_GABOR_GRANGER_READY:
            return {
                ...state,
                gaborGranger: {
                    ...state.gaborGranger,
                    [action.payload.id]: {
                        ...state.gaborGranger[action.payload.id],
                        component_ready: action.payload.component_ready
                    }
                }
            };

        case EDIT_GABOR_GRANGER_PRICES:
            return { ...state, gaborGranger: { ...state.gaborGranger, [action.payload.gabor_granger_surveys.id]: action.payload.gabor_granger_surveys } };

        case EDIT_GABOR_GRANGER_PRODUCT:
            return { ...state, gaborGranger: { ...state.gaborGranger, [action.payload.gabor_granger_surveys.id]: action.payload.gabor_granger_surveys } };

        case EDIT_GABOR_GRANGER_SETTINGS:
            return { ...state, gaborGranger: { ...state.gaborGranger, [action.payload.gabor_granger_surveys.id]: action.payload.gabor_granger_surveys } };

        case FETCH_GABOR_GRANGER_PREVIEW:
            return { ...state, preview: { ...state.preview, gaborGranger: action.payload.gabor_granger_question } }

        case FETCH_VAN_WESTENDORPS:
            return { ...state, vanWestendorp: { ...state.vanWestendorp, ..._.mapKeys(action.payload.van_westendorp_surveys, 'id') } };

        case FETCH_VAN_WESTENDORP:
            return { ...state, vanWestendorp: { ...state.vanWestendorp, [action.payload.van_westendorp_surveys.id]: action.payload.van_westendorp_surveys } };

        case TOGGLE_VAN_WESTENDORP_READY:
            return {
                ...state,
                vanWestendorp: {
                    ...state.vanWestendorp,
                    [action.payload.id]: {
                        ...state.vanWestendorp[action.payload.id],
                        component_ready: action.payload.component_ready
                    }
                }
            };

        case EDIT_VAN_WESTENDORP_PRODUCT:
            return { ...state, vanWestendorp: { ...state.vanWestendorp, [action.payload.van_westendorp_surveys.id]: action.payload.van_westendorp_surveys } };

        case EDIT_VAN_WESTENDORP_SETTINGS:
            return { ...state, vanWestendorp: { ...state.vanWestendorp, [action.payload.van_westendorp_surveys.id]: action.payload.van_westendorp_surveys } };
        
        case ANALYZE_SURVEY:
            return { ...state, analysis: { ...state.analysis, [action.payload.id]: action.payload.results } };

        default:
            return state;
    }
};

export default surveyReducer
